import React from "react"

import Query, {QueryComponentProps} from "@irati/utils/services/apollo/Query"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"

import {HomepageKind} from "@irati/types"
import HomePageQuery from "../../services/queries/HomePage"

export const query = HomePageQuery

export interface Props
  extends Omit<
    QueryComponentProps<
      {homepageDealCategories: any; homepageBanners: any; homepageLanes: any},
      {kind?: HomepageKind}
    >,
    "query"
  > {}

const HomePageQueryComponent: React.FC<Props> = ({children, ...props}) => {
  return (
    <Query query={query} {...props}>
      {(apolloState: ApolloState) => {
        return children(apolloState)
      }}
    </Query>
  )
}

export default HomePageQueryComponent
